import { createAsyncAction, createStandardAction } from 'typesafe-actions';

import env from '@travel/env';
import generateLogger from '@travel/logger';
import { isEmptyObject } from '@travel/utils';

import { fetchDisabledComponentApi } from './api';

import type { DisabledComponent } from 'Common-Types';
import type { AppThunk } from 'typesafe-actions';
const logger = generateLogger();

export const setIsPackagePrice = createStandardAction('SET_COMMON_IS_PACKAGE_PRICE').map(
  (payload: boolean) => ({
    payload,
  }),
);

export const setUserIdentifier = createStandardAction('SET_USER_IDENTIFIER')<string>();

export const fetchDisabledComponentAsync = createAsyncAction(
  'FETCH_COMPONENT_REQUEST',
  'FETCH_COMPONENT_SUCCESS',
  'FETCH_COMPONENT_FAILURE',
)<undefined, DisabledComponent, undefined>();
export const fetchDisabledComponent =
  (): AppThunk =>
  async (dispatch, getState, { apiClient }) => {
    const { common } = getState();
    //do not fetch when data has been fetched
    if (!env('UNIVERSAL_DISABLED_COMPONENT_URL') || !isEmptyObject(common.isDisabledComponent))
      return;

    dispatch(fetchDisabledComponentAsync.request());
    try {
      const response = await fetchDisabledComponentApi(apiClient);
      dispatch(fetchDisabledComponentAsync.success(response));
    } catch (error) {
      logger.error(error);
      dispatch(fetchDisabledComponentAsync.failure());
    }
  };
